<template>
	<!--  -->
	<div class="index page_home bodyBottom bgFBF">
		<div class="index_top">
			<page-search placeholder="搜索" :readonly="true" class="page-search" fieldClass="search_field"
				:righticon="this.publicPath + 'statics/images/search_ico.png'"
				:searchrighticon="this.publicPath + 'statics/images/search_shop_car.png'"></page-search>
			<div class="swipe_wrap">
				<van-swipe :autoplay="3000" class="swiper_style1" v-if="isClient">
					<van-swipe-item v-for="(item, index) in banners" :key="index" @click.stop="swipeClient(item)">
						<div class="ymweapp-wrap" style="height:3.6rem;">
							<img :src="imageUrl + item.thumb" alt="" class="" style="width:100%;height:100%;">
						</div>
					</van-swipe-item>
				</van-swipe>
				<van-swipe :autoplay="3000" class="swiper_style1" v-else>
					<van-swipe-item v-for="(item, index) in banners" :key="index">
						<van-image width="100%" height="100%" :src="imageUrl + item.thumb"
							v-if="!item.miniprogram_appid" @click.stop="swiper_img_click(item.url)" />
						<div class="ymweapp-wrap" style="height:3.6rem;" v-else>
							<img :src="imageUrl + item.thumb" alt="" class="" style="width:100%;height:100%;">
							<wx-open-launch-weapp id="ymweapp" :username="item.miniprogram_appid"
								:path="item.url ? item.url : 'pages/index/index'">
								<script type="text/wxtag-template">
								<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
								<div class="ymweapp-tu"></div>
							</script>
							</wx-open-launch-weapp>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<!-- 头条 匠人 约看等分类 -->
		<div class="index_fenlei">
			<!-- 轮播式 -->
			<!-- <van-swipe :loop="false">
			<van-swipe-item>
				<ul class="fenleiList clearfix flexaround">
					<li class="item f-l" @click="goPage('toutiao-index')">
						<img :src="this.publicPath+'statics/images/home/icon_toutiao.png'" alt="" class="icon">
						<div class="txt">非遗头条</div>
					</li>
					<li class="item f-l" @click="goPage('art-index')">
						<img :src="this.publicPath+'statics/images/home/icon_jiangren.png'" alt="" class="icon">
						<div class="txt">匠人</div>
					</li>
					<li class="item f-l" @click="goPage('yuekan-index')">
						<img :src="this.publicPath+'statics/images/home/icon_yuekan.png'" alt="" class="icon">
						<div class="txt">约看</div>
					</li>
					<li class="item f-l" @click="goPage('shop-btob')">
						<img :src="this.publicPath+'statics/images/home/icon_gongyingshang.png'" alt="" class="icon">
						<div class="txt">兑换专区</div>
					</li>
					<li class="item f-l" @click="goPage('zhibo-index')">
						<img :src="this.publicPath+'statics/images/home/icon_video.png'" alt="" class="icon">
						<div class="txt">视频直播</div>
					</li>
				</ul>
			</van-swipe-item>
			<van-swipe-item>
				<ul class="fenleiList clearfix">
					<li class="item f-l" @click="goPage('dingzhi-index')">
						<img :src="this.publicPath+'statics/images/home/icon_dingzhi.png'" alt="" class="icon">
						<div class="txt">定制</div>
					</li>
					<li class="item f-l" @click="toHistory">
						<img :src="this.publicPath+'statics/images/home/icon_chuanyue.png'" alt="" class="icon">
						<div class="txt">历史记忆</div>
					</li>
					<li class="item f-l" @click="toHealthMap">
						<img :src="this.publicPath+'statics/images/home/icon_healthmap.png'" alt="" class="icon">
						<div class="txt">健康地图</div>
					</li>
				</ul>
			</van-swipe-item>
		</van-swipe> -->
			<!-- 非轮播 -->
			<div class="row">
				<ul class="fenleiList clearfix">
					<li class="item f-l" v-if="!is_review" @click="goPage('toutiao-index')">
						<img :src="this.publicPath + 'statics/images/home/icon_toutiao.png'" alt="" class="icon">
						<div class="txt">非遗头条</div>
					</li>
					<li class="item f-l" @click="goPage('art-index')">
						<img :src="this.publicPath + 'statics/images/home/icon_jiangren.png'" alt="" class="icon">
						<div class="txt">匠人</div>
					</li>
					<li class="item f-l" @click="goPage('yuekan-index')">
						<img :src="this.publicPath + 'statics/images/home/icon_yuekan.png'" alt="" class="icon">
						<div class="txt">约看</div>
					</li>
					<li class="item f-l" v-if="!is_review" @click="goPage('zhibo-index')">
						<img :src="this.publicPath + 'statics/images/home/icon_video.png'" alt="" class="icon">
						<div class="txt">视频直播</div>
					</li>
					<li class="item f-l" @click="goPage('shop-btob')">
						<img :src="this.publicPath + 'statics/images/home/icon_quan.png'" alt="" class="icon">
						<div class="txt">兑换专区</div>
					</li>
				</ul>
			</div>
			<div class="row">
				<ul class="fenleiList clearfix">
					<li class="item f-l" @click="toHistory">
						<img :src="this.publicPath + 'statics/images/home/icon_chuanyue.png'" alt="" class="icon">
						<div class="txt">历史记忆</div>
					</li>
					<li class="item f-l" @click="goPage('dingzhi-index')">
						<img :src="this.publicPath + 'statics/images/home/icon_dingzhi.png'" alt="" class="icon">
						<div class="txt">尊享定制</div>
					</li>
					<!-- <li class="item f-l" @click="goPage('parkmall-list')">
					<img :src="this.publicPath+'statics/images/home/icon_yuanqu.png'" alt="" class="icon">
					<div class="txt">园区</div>
				</li> -->
					<li class="item f-l" @click="goPage('smart-park')">
						<img :src="this.publicPath + 'statics/images/home/icon_smark_park.png'" alt="" class="icon">
						<div class="txt">智慧园区</div>
					</li>
					<!-- <li class="item f-l" @click="goPage('parkmall-list')">
                    <img :src="this.publicPath+'statics/images/home/icon_yuanqu.png'" alt="" class="icon">
                    <div class="txt">园区</div>
                </li> -->
					<li class="item f-l" v-if="!is_review" @click="toHealthMap">
						<img :src="this.publicPath + 'statics/images/home/icon_healthmap.png'" alt="" class="icon">
						<div class="txt">健康地图</div>
					</li>
					<!-- <li class="item f-l" @click="goPage('chain-scancode')">
					<img :src="this.publicPath+'statics/images/home/icon_qukuailian.png'" alt="" class="icon">
					<div class="txt">时代链</div>
				</li> -->
					<li class="item f-l" v-if="!is_review" @click="openCangpin">
						<img :src="this.publicPath + 'statics/images/home/icon_qukuailian.png'" alt="" class="icon">
						<div class="txt">数字藏品</div>
					</li>
					<!-- <li class="item f-l" @click="goServeDev">
					<img :src="this.publicPath+'statics/images/home/icon_more.png'" alt="" class="icon">
					<div class="txt">更多</div>
				</li> -->
				</ul>
			</div>
			<!-- <div class="row">
			<ul class="fenleiList clearfix">
				<li class="item f-l" @click="goPage('smart-park')">
					<img :src="this.publicPath+'statics/images/home/icon_chuanyue.png'" alt="" class="icon">
					<div class="txt">智慧园区</div>
				</li>
			</ul>
		</div> -->
			<!-- <div class="row">
			<ul class="fenleiList clearfix">
				<li class="item f-l" @click="goPage('parkmall-list')">
					<img :src="this.publicPath+'statics/images/home/icon_yuanqu.png'" alt="" class="icon">
					<div class="txt">园区</div>
				</li>
			</ul>
		</div> -->
		</div>
		<!-- 热门推荐 直播+约看 -->
		<div class="tuijian" v-if="liveroom.length != 0 || pos.length != 0 || dingzhi.length != 0">
			<div class="title">热门推荐</div>
			<ul class="list">
				<!-- 直播 -->
				<li class="item" v-for="live_item in liveroom" :key="live_item.id" @click="toZhiboDetail(live_item)">
					<div class="thumb">
						<van-image :src="imageUrl + live_item.thumb" alt="" width="5.59rem" height="3.09rem"
							fit="cover" />
					</div>
					<div class="item_title slh_s">{{ live_item.title }}</div>
					<div class="source">直播</div>
					<!-- <div class="source">{{ live_item.describe }}</div> -->
				</li>
				<!-- 定制 -->
				<li class="item" v-for="dingzhi_item in dingzhi" :key="dingzhi_item.id"
					@click="toDingzhiDetail(dingzhi_item)">
					<div class="thumb">
						<van-image :src="imageUrl + dingzhi_item.thumb" alt="" width="5.59rem" height="3.09rem"
							fit="cover" />
					</div>
					<div class="item_title slh_s">{{ dingzhi_item.title }}</div>
					<div class="source">定制</div>
					<!-- <div class="source">{{ live_item.describe }}</div> -->
				</li>
				<!-- 约看 -->
				<li class="item" v-for="(item, index) in pos" :key="index" @click="toYuanKanDetail(item)">
					<div class="thumb">
						<van-image :src="imageUrl + item.push_thumb" alt="" width="5.59rem" height="3.09rem"
							fit="cover" />
					</div>
					<div class="item_title slh_s">{{ item.title }}</div>
					<div class="source">约看</div>
					<!-- <div class="source">{{ item.describe }}</div> -->
				</li>
			</ul>
		</div>
		<!-- 热门推荐 约看 -->
		<!-- <div class="page_yuekan">
        <div class="tuijian" v-if="pos">
            <div class="title">热门推荐</div>
            <ul class="list clearfix">
                <li class="item f-l" v-for="(item,index) in pos" :key="index" @click="goDetail(item.id)">
                    <img :src="item.thumb" alt="" class="tu">
                </li>
            </ul>
        </div>
    </div> -->
		<!-- 精选头条 -->
		<div class="toutiao" v-if="headlines && headlines.length > 0">
			<div class="toutiao_top">
				<div class="title">精选头条</div>
				<div class="more" @click="toToutiaoList">查看更多</div>
			</div>
			<ul class="list">
				<li class="item" v-for="item in headlines" :key="item.id" @click="toToutiaoDetail(item)">
					<div class="top">
						<div class="thumb">
							<van-image :src="imageUrl + item.thumb" alt="" width="3.24rem" height="2.09rem" fit="cover" />
						</div>
						<div class="title slh">{{ item.title }}</div>
						<div class="info clearfix">
							<span class="f-l source" v-if="item.pushtype">{{ item.pushtype.name }}</span>
							<span class="f-r time">{{ item.timeAgo }}</span>
						</div>
					</div>
					<div class="bottom clearfix">{{ '收藏(' + item.collect_num + ')' }}</div>
				</li>
			</ul>
		</div>
		<!-- 历史上的今天  -->
		<div class="tohistory" v-if="historylist && historylist.length != 0">
			<div class="top">
				<div class="title">历史上的今天</div>
				<div class="more" @click="toHistory">查看更多</div>
			</div>
			<div class="nr">
				<div class="nr_l">
					<img :src="publicPath + 'statics/images/logo_white.png'" alt="" class="tu">
				</div>
				<div class="nr_r">
					<div class="nr_item" v-for="history_item in historylist" :key="history_item.id"
						@click="toHistoryDetail(history_item)">
						<div class="time">{{ history_item.year + history_item.day }}</div>
						<div class="title">{{ history_item.title }}</div>
					</div>
					<!-- <div class="nr_item" @click="toHistory">
					<div class="time">1161年3月11日</div>
					<div class="title">南宋发行纸币"交子"</div>
				</div>
				<div class="nr_item" @click="toHistory">
					<div class="time">1161年3月11日</div>
					<div class="title">南宋发行纸币"交子"</div>
				</div> -->
				</div>
			</div>
		</div>
		<!-- 热销商品 -->
		<div class="rexiao">
			<div class="title">热销商品</div>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData"
					:immediate-check="false">
					<div class="datalist">
						<ul class="list">
							<li class="item" @click="goShopDetail(good)" v-for="(good, index) in goods" :key="index">
								<div :class="good.goodset.is_blockchain ? 'thumb blockchain' : 'thumb'">
									<van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false"
										:src="good.thumb ? imageUrl + good.thumb : $publicData.intangibleDefault" />
								</div>
								<div class="item_xinxi">
									<div class="title_wrap single">
										<div class="title_tag">
											<span class="icon_self" v-if="good.goodset.is_self">自营</span>
											<span class="icon_new" v-if="good.goodset.is_new">最新</span>
										</div>
										<span v-if="good.goodset.is_self && good.goodset.is_new"
											class="title title1 slh_s"> {{ good.title }}</span>
										<span v-else-if="good.goodset.is_self || good.goodset.is_new"
											class="title title2 slh_s"> {{ good.title }}</span>
										<span v-else class="title title3 slh_s"> {{ good.title }}</span>
									</div>
									<div class="info clearfix">
										<div class="shop_name f-l slh_s">{{
				(good.tradesman != null && good.tradesman.nickname != null) ? good.tradesman.nickname : ''
			}}</div>
										<div class="source f-r">{{ good.place }}</div>
									</div>
									<div class="info">
										<span class="f-l price">¥{{ good.prices }}</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</van-list>
			</van-pull-refresh>
			<div class="beian" @click="toBeian">津ICP备15008693号-1</div>
			<van-overlay z-index="20" :show="showPingyao">
				<div class="pingyao-wrap">
					<div class="py-name">已绑定小程序，是否进入查看？</div>
					<div class="py-action">
						<div class="py-confirm ac-cancle" @click="cancelToPingyao">否</div>
						<div class="py-confirm" style="position: relative;">
							<span>是</span>
							<wx-open-launch-weapp id="ymweapp" username="gh_0e1240455bda"
								:path="pingyaoType == 1 ? 'pages/product/list/index?user_uuid=' + pingyaoUuid : 'pages/citypartner/index?agent_uuid=' + pingyaoUuid">
								<script type="text/wxtag-template">
								<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
								<div class="ymweapp-tu"></div>
							</script>
							</wx-open-launch-weapp>
						</div>
					</div>
				</div>
			</van-overlay>
			<van-overlay z-index="20" :show="showSelectRole">
				<div class="pingyao-select">
					<div class="select-name">请选择其中一个身份</div>
					<div class="select-wrap">
						<van-radio-group v-model="pingyaoType">
							<van-radio :name="1" checked-color="rgba(244, 48, 67, 1)">商户</van-radio>
							<van-radio :name="2" checked-color="rgba(244, 48, 67, 1)">分销商</van-radio>
						</van-radio-group>
					</div>
					<div class="select-action">
						<div class="py-btn" @click="confirmPingyaoRole">确认</div>
					</div>
				</div>
			</van-overlay>
			<!-- 绑定二次确认 -->
			<van-overlay z-index="20" :show="showSecConfirm">
				<div class="sec-confirm">
					<div class="confirm-name">是否确认绑定？</div>
					<div class="beizhu-wrap">
						<span class="beizhu-text">备注：</span>
						<van-field v-model="remark" :border="false" placeholder="请输入" />
					</div>
					<div class="confirm-actions">
						<div class="confirm-btn ac-cancle" @click="cancelBind">取消</div>
						<div class="confirm-btn" @click="confirmBind">确认</div>
					</div>
				</div>
			</van-overlay>
		</div>
	</div>
</template>
<script>
import router from '../../../.././router'
import {
	LOGOUT,
	LOGIN
} from '../../../.././vuex/mutation_types'
import PageSearch from '../../../component/search/Index.vue' // 搜索组件
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
	name: 'home-index',
	data() {
		return {
			imageUrl: this.$publicData.uploadImage,
			publicPath: process.env.BASE_URL,
			token: '',
			banners: [
				// {image:'/statics/images/temp/011.png',url:'1'},
				// {image: process.env.BASE_URL + 'statics/images/temp/0.png',url:'2'},
				// {image: process.env.BASE_URL + 'statics/images/temp/1.png',url:'3'},
			],
			headlines: [], // 头条
			liveroom: [], // 直播
			goods: [], // 商品
			pos: [], // 约看
			loading: true,
			finished: false,
			pages: {
				page: 1,
				size: 10
			},
			is_review: false,
			refreshing: false,
			shareConfig: null, // 分享的相关配置
			historylist: [], // 历史今天推荐
			liveroom_nums: null, // 直播数
			lives_nums: null, // 约看数
			total_nums: 5, // 直播+ 定制+ 约看 最多显示5条
			isOpenSpeak: false,
			dingzhi: [], // 推荐的定制
			showPingyao: false, // 遇见平遥 绑码后跳转确认框
			pingyaoCode: null, // 遇见平遥 绑码编号
			pingyaoType: null, // 遇见平遥 绑码类型 1匠人2分销商
			pingyaoUuid: null, // 遇见平遥 绑码后角色uuid
			pingyaoStatus: null, // 遇见平遥 1跳到对应角色页面  2选择其中一种角色 3去绑码
			showSelectRole: false, // 遇见平遥 选中一个角色绑码
			showSecConfirm: false, // 遇见平遥 绑定的二次确认
			remark: null, // 遇见平遥 绑定时加备注
			memberUrl: this.$publicData.domain,
			isClient: false
		}
	},
	components: {
		PageSearch
	},
	created: function () {
		console.log('home created')
		// 数字藏品的中转回跳
		// if(this.$route.query.back == 'cangpin'){
		// 	window.open(this.$publicData.cangpinUrl);
		// };
		//根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
		if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
			this.isClient = true
			var params = {
				data: {
					// hiddenNavi: true,
					'naviTitle': '时代记忆',
					levitate: true,
					showStatusBar: true,
					hiddenBack: true
				}
			};
			this.$bridge.callhandler("sdjy://navigation/style", params, (data) => { });
			//获取用户信息
			var memberParams = {
				data: {
					notCallLogin: 1,
				},
			};
			this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
				(data) => {
					if (data.code == 200) {
						this.token = data.result.token;
						// this.openSpeak()
					} else {
						this.token = "";
					}
				}
			);
			//注册方法，客户端重新进入页面刷新数据
			this.$bridge.registerhandler(
				"sdjy://common/refreshPage",
				(data, responseCallback) => {
					// alert(JSON.stringify(data));
					// this.openSpeak()
					responseCallback('');
				}
			);
			this.getReviewApp()
		} else {
			this.token = this.$store.getters.token;
			// 遇见平遥 改为商户&分销商小程序码和业务员普通二维码 结合；所以此页面的遇见平遥相关的用不上了
			// let pingyaoCode = this.$route.query.pingyaoqrcodenum;
			// if(pingyaoCode){
			// 	this.pingyaoCode = pingyaoCode;
			// 	if(this.token){
			// 		this.verfyPingyaoCode();
			// 	}else{
			// 		localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
			// 		this.$router.push({
			// 			path: '/login'
			// 		})
			// 	}
			// }
		}
		this.getData()
		var token = this.$route.query.token
		console.log('111 token:', token)
		if (token != null && token != undefined && token != '') {
			this.getUserInfo(token)
		}

		this.getReviewApp()
	},
	mounted() {
		// let that = this;
		// let btn = document.getElementById('ymweapp');
		// btn.addEventListener('click',function(e){
		// 	that.showPingyao = false;
		// });
		// btn.addEventListener('launch', function (e) {
		// 	console.log('跳转小程序success');
		// 	that.showPingyao = false;
		// 	// localStorage.setItem('pingyaoNum',-1);
		// });
		// btn.addEventListener('error', function (e) {
		// 	console.log('跳转小程序fail', e.detail);
		// });
	},
	methods: {
		// 是否App审核
		getReviewApp() {
			console.log('getReviewApp')
			var that = this
			var params = {

			}
			this.$api.index.reviewApp(params).then(res => {
				console.log('resreviewApp')
				console.log(res)
				if (res.code == 200) {
					that.is_review = (res.result.is_review > 0) ? true : false
					console.log(that.is_review)
				}
			})
		},
		/**
		 * @name: 跳转数字藏品
		 * @return {*}
		 * @desc: 
		 */
		openCangpin() {
			window.open(this.$publicData.cangpinUrl);
		},
		/**
		 * @name: 取消绑定
		 * @return {*}
		 * @desc: 
		 */
		cancelBind() {
			this.showSecConfirm = false;
			// localStorage.setItem('pingyaoNum',-1);
			window.history.replaceState(null, null, this.memberUrl);
		},
		/**
		 * @name: 确认绑定
		 * @return {*}
		 * @desc: 遇见平遥
		 */
		confirmBind() {
			let that = this;
			if (!this.remark) {
				this.$toast("备注必须填写");
				return;
			};
			this.showSecConfirm = false;
			if (this.pingyaoStatus == 3) {
				// 绑码
				that.bindPingyaoCode();
			} else if (this.pingyaoStatus == 2) {
				// 选择其中一种角色 绑码
				that.showSelectRole = true;
			}
		},
		/**
		 * @name: 取消进入平遥
		 * @return {*}
		 * @desc: 遇见平遥
		 */
		cancelToPingyao() {
			this.showPingyao = false;
			window.history.replaceState(null, null, this.memberUrl);
			// localStorage.setItem('pingyaoNum',-1);
		},
		/**
		 * @name: 确认用哪一种身份去绑定
		 * @return {*}
		 * @desc: 遇见平遥
		 */
		confirmPingyaoRole() {
			let that = this;
			that.showSelectRole = false;
			that.bindPingyaoCode();
		},
		/**
		 * @name: 绑编号码
		 * @return {*}
		 * @desc: 遇见平遥
		 */
		bindPingyaoCode() {
			let that = this;
			let params = {
				token: this.token,
				qrcode_num: this.pingyaoCode,
				role: this.pingyaoType,
				user_uuid: this.pingyaoUuid,
				mark: this.remark
			};
			this.$api.common.bindqrcode(params).then(res => {
				if (res.code == 200) {
					this.showPingyao = true;
					// localStorage.setItem('pingyaoNum',-1);
					window.history.replaceState(null, null, this.memberUrl);
				} else {
					this.$toast(res.message);
					// localStorage.setItem('pingyaoNum',-1);
					window.history.replaceState(null, null, this.memberUrl);
				}
			})
		},
		/**
		 * @name: 验证编号码是否可用
		 * @params code
		 * @return {*}
		 * @desc: 遇见平遥
		 */
		verfyPingyaoCode() {
			let that = this;
			let params = {
				token: this.token,
				qrcode_num: this.pingyaoCode
			};
			this.$api.common.verfyRole(params).then(res => {
				if (res.code == 200) {
					this.pingyaoType = res.result.type; // 1匠人 2分销商
					this.pingyaoStatus = res.result.status; // 1跳到对应角色页面  2选择其中一种角色 3去绑码
					this.pingyaoUuid = res.result.user_uuid;
					if (this.pingyaoStatus == 1) {
						this.showPingyao = true;
						window.history.replaceState(null, null, this.memberUrl);
					} else {
						this.showSecConfirm = true;
						this.remark = null;
					}
				} else {
					window.history.replaceState(null, null, this.memberUrl);
					this.$toast(res.message);
				}
			})
		},
		getUserInfo(token) {
			var that = this
			var params = {
				token: token
			}
			this.$api.user.index(params).then(res => {
				console.log('res')
				console.log(res)
				if (res.code == 200) {

					var info = res.result.info
					var name = info.nickname == null ? info.username : info
					that.$store.commit(LOGIN, {
						name: name,
						token: token,
						uuid: info.uuid,
					});
				}
			})
		},
		// 获取数据
		getData() {
			// var url = "http://miniwechat.xiaoxiongxiche.com/export/2021-02-10-2021-02-10洗车明细.xlsx"
			// url = url.replace("http://","https://")
			// var newUrl = encodeURI(url);
			// console.log('url:',newUrl)
			var params = {
				page: this.pages.page,
				size: this.pages.size,
				sorce: 1
			}
			this.$api.index.index(params).then(res => {
				if (res.code == 200) {
					console.log('res')
					console.log(res)
					this.banners = res.result.banner
					// 头条
					var headlines = res.result.headlines
					// 头条 发布时间格式
					for (var k in headlines) {
						// 计算时间差
						if (headlines[k].created_at) {
							var time_headline = headlines[k].created_at
							var dateTimeStamp = this.getTimes(time_headline)
							headlines[k].timeAgo = this.timeago(dateTimeStamp)
						}
					}
					this.headlines = headlines
					// 历史今天
					var historylist = res.result.historylist
					// 历史今天 日期格式
					for (var j in historylist) {
						var time = historylist[j].push_at
						var timeArr = time.split(' ')
						var timeInfo = timeArr[0].split('-')
						// console.log(timeInfo)
						if (timeInfo[0] == '') {
							historylist[j].bc = 1 // 公元前
							historylist[j].year = '公元前' + timeInfo[1] + '年'
							historylist[j].day = timeInfo[2] + '月' + timeInfo[3] + '日'
						} else {
							historylist[j].bc = 0 // 公元纪年
							historylist[j].year = timeInfo[0] + '年'
							historylist[j].day = timeInfo[1] + '月' + timeInfo[2] + '日'
						}
					}
					this.historylist = historylist
					// 直播、定制、约看 共5条,按照此排列最多五条
					// 直播
					this.liveroom = res.result.liveroom
					this.liveroom_nums = res.result.liveroom.length
					if (this.liveroom_nums > this.total_nums) {
						this.liveroom = this.liveroom.slice(0, this.total_nums)
					} else {
						// console.log('直播数',this.liveroom_nums)
						// 定制
						var dingzhiArr = res.result.custommade_list
						var dingzhi_nums = dingzhiArr.length
						var sec_nums = this.total_nums - this.liveroom_nums
						if (sec_nums > 0) {
							if (dingzhiArr.length > sec_nums) {
								this.dingzhi = dingzhiArr.slice(0, sec_nums)
							} else {
								this.dingzhi = dingzhiArr
							}
						}
						// 约看
						var yuekanArr = res.result.lives
						var yuekan_nums = yuekanArr.length
						var third_nus = this.total_nums - this.liveroom_nums - dingzhi_nums
						if (third_nus > 0) {
							if (yuekanArr.length > third_nus) {
								this.pos = yuekanArr.slice(0, third_nus)
							} else {
								this.pos = yuekanArr
							}
						}
					}
					// 商品
					var list = res.result.goods
					if (this.pages.page == 1) {
						this.goods = []
					}
					for (var i in list) {
						if (this.goods.length >= 20) {
							this.finished = true
							this.refreshing = false
							break
						}
						this.goods.push(list[i])
					}
					if (list.length == 0) {
						// 数据加载完
						this.finished = true
						this.refreshing = false
						return
					}
				} else {
					// 关闭加载状态
					this.finished = true
					return
				}
				// 分页加载
				this.pages.page++
				this.refreshing = false
				this.loading = false
				// console.log('this.refreshing', this.refreshing)
			})
		},
		openSpeak() {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {
						notCallLogin: 1,
					},
				};
				this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.checkTrandsman()
						} else {
							this.token = "";
						}
					}
				);
			}
		},
		checkTrandsman() {
			console.log('123')
			if (!this.token) {
				return
			}
			var that = this
			var params = {
				token: this.token,
			}
			this.$api.user.index(params).then(res => {
				console.log('res')
				console.log(res)
				if (res.code == 200) {
					if (res.result.info.userrole.is_tradesman == 1) {
						that.openSpeakAction(res.result.info.uuid)
					}
				}
			})
		},
		openSpeakAction(uuid) {
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//启动播报监听
				var voiceParams = {
					'data': {
						'roomid': uuid
					}
				}
				if (that.isOpenSpeak) {
					return
				}
				that.isOpenSpeak = true
				console.log('sdjy://public/orderSpeak')
				this.$bridge.callhandler('sdjy://public/orderSpeak', voiceParams, (data) => {
					if (data.code == 200) {

					}
				})
			}

		},
		// 点击轮播图
		swiper_img_click(url) {
			console.log(url)
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': url
					}
				}
				this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				window.open(url)
			}
		},
		swipeClient(item) {
			console.log('swipeClient:', item)
			console.log('swipeClient:', item.miniprogram_appid)
			if (this.isClient) {
				if (item.miniprogram_appid != null && item.miniprogram_appid != undefined && item.miniprogram_appid != '') {

					var params = item
					var params = {
						'data': item
					}
					console.log('swipeClient1:', params)
					// 跳转小程序
					this.$bridge.callhandler('sdjy://public/openMiniprogram', params, (data) => {

					})
				} else {

					var params = {
						'data': {
							'url': item.url
						}
					}
					this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

					})
				}

			}
		},
		// 
		goPage: function (name) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				name = name.replace("-", "/")
				var params = {
					'data': {
						'url': this.$publicData.clientUrl + '/' + name
					}
				}
				this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				this.$router.push({
					name: name
				})
			}
		},
		goRed() {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var name = "art/detail?tradesmanId=29"
				var params = {
					'data': {
						'url': this.$publicData.clientUrl + '/' + name
					}
				}
				this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				this.$router.push({
					path: '/art/detail',
					query: {
						tradesmanId: 29
					}
				})
			}
		},
		// 去商品详情页
		goShopDetail: function (good) {
			console.log(good)
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var p = "?goodsId=" + good.id;
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/shop/detail" + p
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: "/shop/detail",
					query: {
						goodsId: good.id,
					},
				});
			}
		},
		// 约看详情
		goDetail(id) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var p = "?id=" + id;
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/yuekan/detail" + p
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/yuekan/detail',
					query: {
						id: id
					}
				})
			}
		},
		// 刷新
		onRefresh() {
			// console.log('触发了')
			// 清空列表数据
			this.finished = false;

			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.pages.page = 1
			this.getData();
		},
		// 获取分享参数 -- 用于配微信分享
		getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
			this.$api.index.commonShare({
				url: url
			}).then(res => {
				if (res.code == 200) {
					this.shareConfig = res.result
					// console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
				}
			})
		},
		// 分享
		shareFun() {
			var that = this
			wx.config({
				debug: that.shareConfig.debug,
				beta: that.shareConfig.beta,
				jsApiList: that.shareConfig.jsApiList,
				openTagList: that.shareConfig.openTagList,
				appId: that.shareConfig.appId,
				nonceStr: that.shareConfig.nonceStr, // 随机串
				timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
				signature: that.shareConfig.signature // 签名
			});
			// 分享
			wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: '时代记忆', // 分享标题
					desc: '时代记忆', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
				wx.updateAppMessageShareData(shareData);
				wx.updateTimelineShareData(shareData);
			});
		},
		// 去历史上的今天
		toHistory() {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/tohistory/index"
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/tohistory/index'
				})
			}
		},
		toHealthMap() {
			var url = "https://health.shidaijiyi.com/"
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: url
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				window.open(url)
			}
		},
		// 历史上今天 详情
		toHistoryDetail(item) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/tohistory/detail?history_id=" + item.id
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/tohistory/detail',
					query: {
						history_id: item.id
					}
				})
			}
		},
		// 去头条列表
		toToutiaoList() {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/toutiao/index"
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/toutiao/index'
				})
			}
		},
		// 去头条详情
		toToutiaoDetail(item) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/toutiao/detail?headline_id=" + item.id
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/toutiao/detail',
					query: {
						headline_id: item.id
					}
				})
			}
		},
		// 约看详情
		toYuanKanDetail(item) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/yuekan/detail?id=" + item.id
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/yuekan/detail',
					query: {
						id: item.id
					}
				})
			}
		},
		// 直播详情
		toZhiboDetail(item) {
			var that = this
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/zhibo/detail?id=' + item.id
					}
				}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				that.$router.push({
					path: `/zhibo/detail`,
					query: {
						id: item.id
					}
				})
			}
		},
		// 定制详情
		toDingzhiDetail(item) {
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
				var url = this.$publicData.clientUrl
				url = url + '/dingzhi/detail?id=' + item.id
				var params = {
					'data': {
						'url': url
					}
				}
				this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				this.$router.push({
					path: '/dingzhi/detail',
					query: {
						id: item.id
					}
				})
			}
		},
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15 12:00:00'
		getTimes(strdate) {
			var arr = strdate.split(/[- : \/]/);
			var date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
			return date;
		},
		// 时间差
		timeago(dateTimeStamp) {
			var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
			var hour = minute * 60;
			var day = hour * 24;
			var week = day * 7;
			var halfamonth = day * 15;
			var month = day * 30;
			var now = new Date().getTime();   //获取当前时间毫秒
			// console.log(now)
			var diffValue = now - dateTimeStamp;//时间差
			var result = ''
			if (diffValue < 0) {
				return;
			}
			var minC = diffValue / minute;  //计算时间差的分，时，天，周，月
			var hourC = diffValue / hour;
			var dayC = diffValue / day;
			var weekC = diffValue / week;
			var monthC = diffValue / month;
			if (monthC >= 1 && monthC <= 3) {
				result = " " + parseInt(monthC) + "月前"
			} else if (weekC >= 1 && weekC <= 3) {
				result = " " + parseInt(weekC) + "周前"
			} else if (dayC >= 1 && dayC <= 6) {
				result = " " + parseInt(dayC) + "天前"
			} else if (hourC >= 1 && hourC <= 23) {
				result = " " + parseInt(hourC) + "小时前"
			} else if (minC >= 1 && minC <= 59) {
				result = " " + parseInt(minC) + "分钟前"
			} else if (diffValue >= 0 && diffValue <= minute) {
				result = "刚刚"
			} else {
				var datetime = new Date();
				datetime.setTime(dateTimeStamp);
				var Nyear = datetime.getFullYear();
				var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
				var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
				var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
				var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
				var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
				result = Nyear + "-" + Nmonth + "-" + Ndate
			}
			// console.log('时间差',result)
			return result;
		},
		// 开发中
		goServeDev() {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					data: {
						url: this.$publicData.clientUrl + "/system/develop"
					},
				};
				this.$bridge.callhandler(
					"sdjy://public/openNewWebView",
					params,
					(data) => { }
				);
			} else {
				this.$router.push({
					path: '/system/develop'
				})
			}

		},
		toBeian() {
			window.open('https://beian.miit.gov.cn/')
		},
	}


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.bgFBF {
	background-color: #FBFBFF;
}

.rexiao {
	background-color: #ffffff;
}

.pingyao-wrap {
	width: 8rem;
	border-radius: .4rem;
	background: #ffffff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: .4rem;
}

.pingyao-wrap .py-name {
	font-size: .4rem;
	text-align: center;
}

.pingyao-wrap .py-action {
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-top: 0.4rem;
	font-size: .38rem;
}

.pingyao-wrap .py-action .py-confirm {
	width: 2.67rem;
	height: 0.93rem;
	border-radius: 0.47rem;
	font-size: 0.4rem;
	text-align: center;
	line-height: 0.93rem;
	color: rgba(255, 255, 255, 1);
	background: linear-gradient(90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
}

.pingyao-wrap .py-action .py-confirm.ac-cancle {
	background: rgba(0, 0, 0, .2);
}

.pingyao-wrap #ymweapp {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
}

/* 遇见平遥 选角色 */
.pingyao-select {
	width: 8rem;
	border-radius: .4rem;
	background: #ffffff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: .4rem;
}

.pingyao-select .select-name {
	font-size: .4rem;
	text-align: center;
}

.pingyao-select .select-wrap .van-radio {
	margin-top: .4rem;
}

.pingyao-select .select-action {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.4rem;
	font-size: .38rem;
}

.pingyao-select .select-action .py-btn {
	width: 2.67rem;
	height: 0.93rem;
	border-radius: 0.47rem;
	font-size: 0.4rem;
	text-align: center;
	line-height: 0.93rem;
	color: rgba(255, 255, 255, 1);
	background: linear-gradient(90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
}

/* 遇见平遥 二次确认 */
.sec-confirm {
	width: 8rem;
	border-radius: .4rem;
	background: #ffffff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: .4rem;
}

.sec-confirm .confirm-name {
	font-size: .4rem;
	text-align: center;
}

.sec-confirm .confirm-actions {
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-top: 0.4rem;
	font-size: .38rem;
}

.sec-confirm .confirm-actions .confirm-btn {
	width: 2.67rem;
	height: 0.93rem;
	border-radius: 0.47rem;
	font-size: 0.4rem;
	text-align: center;
	line-height: 0.93rem;
	color: rgba(255, 255, 255, 1);
	background: linear-gradient(90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
}

.sec-confirm .confirm-actions .confirm-btn.ac-cancle {
	background: rgba(0, 0, 0, .2);
}

.sec-confirm .beizhu-wrap {
	display: flex;
	align-items: flex-end;
	height: 0.77rem;
	line-height: 0.77rem;
	margin-top: 0.2rem;
}

.sec-confirm .beizhu-wrap .van-cell {
	width: auto;
	padding: 0;
	line-height: unset;
	border-bottom: 0.0134rem solid rgba(0, 0, 0, .1);
}

/* 轮播图上的广告位 */
.swipe_wrap .ymweapp-wrap {
	position: relative;
}

.swipe_wrap .ymweapp-wrap #ymweapp {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
}
</style>
